import { Alert, Snackbar } from "@mui/material";
import { useContext } from "react";
import { SnackContext } from "../SnackContext";

export const SnackBarAlert = () => {
	const { openSnack, setOpenSnack, getSeverity, snackDisplay, snackDelay } =
		useContext(SnackContext);

	return (
		<>
			<Snackbar
				open={openSnack}
				autoHideDuration={snackDelay}
				onClose={() => setOpenSnack(false)}
			>
				<Alert
					onClose={() => setOpenSnack(false)}
					severity={getSeverity}
				>
					{snackDisplay}
				</Alert>
			</Snackbar>
		</>
	);
};
